module.exports = __webpack_public_path__ + "media/img/themes/ticket-in-sing-in-logo-7c969a55108338a42096445e027ca390.png";